/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc メッセージ情報関連の定数クラス
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */

export default class {
  /**
   * メッセージ種別 : Text
   */
  static get MESSAGE_TYPE_TEXT() {
    return '0'
  }
  /**
   * メッセージ種別 : Image
   */
  static get MESSAGE_TYPE_IMAGE() {
    return '1'
  }
  /**
   * メッセージ種別 : Video
   */
  static get MESSAGE_TYPE_VIDEO() {
    return '2'
  }
  /**
   * メッセージ種別 : File
   */
  static get MESSAGE_TYPE_FILE() {
    return '12'
  }
  /**
   * メッセージ種別 : ButtonList
   */
  static get MESSAGE_TYPE_BUTTON_LIST() {
    return '16'
  }
  /**
   * メッセージ種別 : Confirm
   */
  static get MESSAGE_TYPE_CONFIRM() {
    return '17'
  }
  /**
   * メッセージ種別 : ImageUrl
   */
  static get MESSAGE_TYPE_IMAGE_URL() {
    return '18'
  }
  /**
   * メッセージ種別 : SwitchConfirm
   */
  static get MESSAGE_TYPE_SWITCH_CONFIRM() {
    return '19'
  }
  /**
   * メッセージ種別 : SwitchConfirm
   */
  static get MESSAGE_TYPE_SURVEY_REQUEST() {
    return '22'
  }
  /**
   * メッセージ配信種別 : FastchatからFastHelpへのメッセージ
   */
  static get DISTRIBUTION_TYPE_FC_TO_FH() {
    return '0'
  }
  /**
   * メッセージ配信種別 : FastHelpからFastchatへのメッセージ
   */
  static get DISTRIBUTION_TYPE_FH_TO_FC() {
    return '1'
  }
  /**
   * メッセージオプション-ボタン種別 : text
   */
  static get MESSAGE_OPTION_BUTTON_TYPE_TEXT() {
    return 'text'
  }
  /**
   * メッセージオプション-ボタン種別 : postback
   */
  static get MESSAGE_OPTION_BUTTON_TYPE_POSTBACK() {
    return 'postback'
  }
  /**
   * メッセージオプション-ボタン種別 : url
   */
  static get MESSAGE_OPTION_BUTTON_TYPE_URL() {
    return 'url'
  }
  /**
   * SNS担当者番号 : Bot
   */
  static get SNS_STAFF_ID_BOT() {
    return 2
  }
  /**
   * 確認種別 : Manual対応切替
   */
  static get CONFIRM_TYPE_SWITCH_MANUAL() {
    return 'switchManual'
  }
}



// WEBPACK FOOTER //
// ./src/constants/MessageInfoConst.js